import Comment from "../../api/types/Comment";
import normalizeComment from "../normalizer/normalizeComment";

type Normalized = ReturnType<typeof normalizeComment>

export default function denormalizeComment(normalized: Normalized, commentId: string): Comment | undefined {
    return normalized.comments[commentId];
}